export interface ClientContext {
    teamId: number;
    orgUnitId?: number;
    groupId?: string;
}

export interface ContextClientFactory<T> {
    createClient(context: ClientContext): T;
}

export class ContextClient<T> {
    private cache: Map<string, T> = new Map();

    constructor(private factory: ContextClientFactory<T>) {}

    protected getClient(context: ClientContext): T {
        const cacheKey = this.createCacheKey(context);

        if (this.cache.has(cacheKey)) {
            return this.cache.get(cacheKey)!;
        }

        const client = this.factory.createClient(context);
        this.cache.set(cacheKey, client);

        return client;
    }

    private createCacheKey(context: ClientContext): string {
        const parts = [
            `team_id_${context.teamId || ''}`,
            `org_unit_id_${context.orgUnitId || ''}`,
            `group_id_${context.groupId || ''}`,
        ];

        return parts.join('|');
    }
}
